import { useState } from 'react';
import { VStack } from '@chakra-ui/react';

import CompanyGeneralCompany from './accordionSections/CompanyGeneralCompany';
import CompanyGeneralTCAPSettings from './accordionSections/CompanyGeneralTCAPSettings';
import CompanyGeneralContact from './accordionSections/CompanyGeneralContact';
import ActiveStatus from './formFields/ActiveStatus';
import DataResidencyRegion from './formFields/DataResidencyRegion';
import EngineLocations from './formFields/EngineLocations';
import useGetEngineLocations from '../queries/useGetEngineLocations';
import useGetDataResidencyLocations from '../queries/useGetDataResidencyLocations';

// Add Mode fields
import CompanyName from './formFields/CompanyName';
import DefaultPlan from './formFields/DefaultPlan';

const CompanyGeneral = ({
    darkMode,
    errors,
    touched,
    isAddMode,
    defaultPlansData,
}) => {
    const [engineLocations, setEngineLocations] = useState([]);
    const [dataResidencyLocations, setDataResidencyLocations] = useState([]);

    const { isLoading: isLoadingEngineLocations } =
        useGetEngineLocations(setEngineLocations);
    const { isLoading: isLoadingDataResidencyLocations } =
        useGetDataResidencyLocations(setDataResidencyLocations);

    return (
        <VStack spacing={1} align="stretch">
            {isAddMode && (
                <>
                    <CompanyName
                        key="companyName"
                        errors={errors}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                    />
                    <DefaultPlan
                        key="defaultPlan"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                        defaultPlansData={defaultPlansData}
                    />
                    <DataResidencyRegion
                        key="dataResidencyRegion"
                        darkMode={darkMode}
                        dataResidencyLocations={dataResidencyLocations}
                        isLoadingDataResidencyLocations={
                            isLoadingDataResidencyLocations
                        }
                    />
                    <EngineLocations
                        key="engineLocations"
                        errors={errors}
                        darkMode={darkMode}
                        engineLocations={engineLocations}
                        isLoadingEngineLocations={isLoadingEngineLocations}
                    />
                </>
            )}
            {!isAddMode && (
                <>
                    <ActiveStatus darkMode={darkMode} />
                    <CompanyGeneralCompany
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                    />
                    <CompanyGeneralTCAPSettings
                        errors={errors}
                        touched={touched}
                        isAddMode={isAddMode}
                        darkMode={darkMode}
                        engineLocations={engineLocations}
                        isLoadingEngineLocations={isLoadingEngineLocations}
                        dataResidencyLocations={dataResidencyLocations}
                        isLoadingDataResidencyLocations={
                            isLoadingDataResidencyLocations
                        }
                    />
                    <CompanyGeneralContact
                        errors={errors}
                        touched={touched}
                        isAddMode={isAddMode}
                        darkMode={darkMode}
                    />
                </>
            )}
        </VStack>
    );
};

export default CompanyGeneral;
